<template>
    <div class="content">
        <!--单张-->
        <div class="advtisement" v-if="topImg.banner.thumb_url">
            <img :src="topImg.banner.thumb_url" alt="广告图"  @click="goDatails(topImg.banner.url)">
        </div>
         <!--两张-->
        <div class="advertisement-two" v-if="middelImgs.length > 0">
            <img v-for="(item, index) in middelImgs" :key="index" :src="item.banner.thumb_url" @click="goDatails(topImg.banner.url)" alt="广告图">
        </div>
         <!--四张-->
        <div class="advertisement-four" v-if="fourImsg.length > 0">
            <img v-for="(item, index) in fourImsg" :key="index" :src="item.banner.thumb_url" @click="goDatails(topImg.banner.url)" alt="广告图">
        </div>
    </div>
</template>
<script>
import { Dialog } from "vant";
import { getData } from "../Interface/http.js";
export default {
    data() {
        return {
            topImg: {
                banner:{}
            },
            middelImgs: [],
            fourImsg: []
        }
    },
    props: ["oneId","twoId","fourId"],
    methods: {
        //跳转详情页面
        goDatails(url) {
            if(!url) {
                return;
            }
            if(!url.includes('jfbst.com')) {
                Dialog.confirm({
                    message: "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服"
                }).then(() => {
                window.location.href = url;
                })
            } else {
                window.location.href = url;
            }
        },
        //获取头部图片
        getTopImg() {
            let me = this;
            getData(`/recommend-lists?position=${me.oneId}`).then((res) => {
                me.topImg = res.data[0] || {banner:{}};
            });
        },
        //获取中部两图片
        getMiddelImg() {
            let me = this;
            getData(`/recommend-lists?position=${me.twoId}`).then((res) => {
                me.middelImgs = res.data;
            });
        },
        //获取底部4图片
        getFourImgs() {
            let me = this;
            getData(`/recommend-lists?position=${me.fourId}`).then((res) => {
                me.fourImsg = res.data;
            });
        }
    },
    mounted() {
        this.getTopImg();
        this.getMiddelImg();
        this.getFourImgs();
    }
}
</script>
<style scoped>
.content {
    width: calc(100% - 20px);
    padding: 0px 10px 0 10px;
}
.advtisement{
  width:100%;
  margin-bottom: 5px;
  overflow: hidden;
}
.advtisement img{
    width:100%;
    border-radius: 5px;
}
.advertisement-two {
    display: flex;
    margin-bottom: 5px;
    justify-content: space-between;
    width:100%;
}
.advertisement-two img {
    width: 49%;
    border-radius: 5px;
}
.advertisement-four {
    display: flex;
    margin-bottom: 5px;
    justify-content: space-between;
    width:100%;
}
.advertisement-four img {
    width: calc((100% - 10px) / 4);
    border-radius: 5px;
}
</style>